<template>
  <div class="jump-top">
    <div class="qrcode">
      <img src="../assets/icon-qrcode-btn.png">
      <div class="float-pop">
        <img src="../assets/image-qr-login.png" class="qr">
        <p class="txt">微&nbsp;&nbsp;信&nbsp;&nbsp;扫&nbsp;&nbsp;码<br>手机访问斐艺</p>
      </div>
    </div>
    <i-back-top :height="250" :bottom="80" :right="40" :duration="300">
      <img src="../assets/icon-top.png" class="top">
    </i-back-top>
  </div>
</template>

<script>
import { BackTop } from 'iview'
export default {
  data () {
    return {}
  },
  components: {
    'i-back-top': BackTop
  }
}
</script>

<style lang="stylus" scoped>
.top
  width: 56px
.qrcode
  fixed: bottom 138px right 40px
  width: 56px
  height: 56px
  z-index: 11
  &>img
    width: 100%
    height: 100%
  &:hover
    .float-pop
      display: block
  .float-pop
    display: none
    absolute: right 76px bottom
    padding: 26px 26px 16px
    background-color: $white
    box-shadow:0 0 14px 0 $grey-e5
    &:before
      absolute: right -24px bottom 28px
      content: ''
      width: 0
      height: 0
      border: 12px solid
      border-color: transparent transparent transparent $white
    .qr
      width: 126px
      height: 126px
    .txt
      text-align: center
      font-size: 12px
      font-weight: 400
      color: $grey-high
      line-height: 17px
</style>



// WEBPACK FOOTER //
// src/components/JumpTop.vue